module.exports = __webpack_public_path__ + "static/media/gal1.046bef3b.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/images/gal1.JPG
// module id = 611
// module chunks = 0